import axios from "axios";
import { useEffect, useState } from "react";
import { baseURL, USER, USERS } from "../../Api/Api";
import Cookie from "cookie-universal";
import TableShow from "../../Components/Dashboard/TableShow";
import ContentHeader from "../../Components/Dashboard/ContentHeader";
import { faUsers} from "@fortawesome/free-solid-svg-icons";
export default function Users(){
    //useState for users
    const[data,setData]=useState([]);

    //useState for current user
    const[currentUser,setcurrentUser]=useState([]);
   //pagination
    const limit=5;
    const[page,setPage]=useState(1);
    //cookie
    const cookie=Cookie();

    //get current user
    useEffect(()=>{
     
        try{
            axios.get(`${baseURL}/${USER}`,{
                headers:{
                    Authorization: 'Bearer ' + cookie.get('e-commerce'),
                },
            })
            //i am useing then because i am useing try with out (asyn,await)
            .then((res)=>{setcurrentUser(res.data);
                  
        });
        }
        
        catch(err){
            console.log(err);
        }
    },[]);

    //get users
    useEffect(()=>{
        try{
            axios.get(`${baseURL}/${USERS}`,{
                headers:{
                    Authorization: 'Bearer ' + cookie.get('e-commerce'),
                },
            })
            //i am useing then because i am useing try with out (asyn,await)
            .then((data)=>setData(data.data));
        }
        
        catch(err){
            console.log(err);
        }
    },[]);
    
    //object header for table
    const header=[
       
       {
          key:'name',
          name:'User Name'
       },
       {
          key:'email',
          name:'Email'
       },
        {
          key:'role',
          name:'Role'
       },
       {
          key:'created_at',
          name:'created'
       }
    ]
    //object content header
    const HeaderInfo={
        title:'Users',
        BtnName:'Add',
        icon:faUsers,
        show:true,
        BtnClick:()=>{ window.location.pathname = 'dashboard/user/add'; }
    }

   //Delete user
    async function handleDelete(id){
      try{
        await axios.delete(`${baseURL}/${USER}/${id}`,{
                headers:{
                    Authorization: 'Bearer ' + cookie.get('e-commerce'),
                },
            }
        
        );
        setData((prov)=>prov.filter((item)=>item.id!==id));
      }
      catch(err){
        console.log(err);
      }
    } 
    return (
      <>
    <div className="bg-white w-100" style={{height:'100vh'}}>
    <ContentHeader HeaderInfo={HeaderInfo} />
     <TableShow
      header={header}
       data={data}
        delete={handleDelete}
         currentUser={currentUser}
         limit={limit}
      page={page}
      setPage={setPage}
      typeSearch='name'
      />
    </div>
    </>
  );
}



    